import { DeepReadonly, IGlobalCustomDocuments } from 'types';
import { deepFreeze } from '../utils/deepFreeze';

export const defaultCustomDocuments: DeepReadonly<IGlobalCustomDocuments> = deepFreeze({
  documents: {},
  followUpDocuments: {
    beforeArrivalDocuments: {},
    afterArrivalDocuments: {}
  },
  financeDocuments: {}
});
